import React, { useState } from "react";
import Loader from "../../Components/Loader/Loader";
import { fetchVehicle } from "../../Redux/Actions/Vehicles";
import { convertToMonthDayYear } from "../../utils/common";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import "./Vehicle.scss";

const Vehicle = (props) => {
  const [sortOrder, setSortOrder] = useState("oldest");
  const { data: response, isLoading, isError } = useQuery(
    ["vehicle", props.match.params.id],
    () => fetchVehicle(props.match.params.id)
  );

  const vehicle = response?.data || {};
  const activities = (vehicle.activity_details || [])
    .filter((item) => item.activity_type !== "Storage")
    .map((item, originalIndex) => ({ item, originalIndex }))
    .sort((a, b) => {
      const dateA = String(a.item.date || "");
      const dateB = String(b.item.date || "");
      const dateResult = dateA.localeCompare(dateB);
      if (dateResult !== 0) {
        return sortOrder === "oldest" ? dateResult : -dateResult;
      }
      // Same-day activities retain their original API order in both views.
      return a.originalIndex - b.originalIndex;
    })
    .map(({ item }) => item);

  const formatWorkOrder = (value = "") => {
    const parts = String(value || "").split("-");
    return parts[parts.length - 1];
  };

  const vehicleTitle = [
    vehicle.year,
    vehicle.vehicle_make,
    vehicle.vehicle_model,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="ds-vehicle-page">
      {isLoading && <Loader />}

      <div className="ds-vehicle-page__navigation">
        <Link to="/vehicles" className="ds-vehicle-page__back">
          <span aria-hidden="true">←</span> Vehicles
        </Link>
        <span className="ds-vehicle-page__eyebrow">VEHICLE SCHEDULE</span>
      </div>

      {isError ? (
        <div className="ds-vehicle-history__empty">
          Unable to load this vehicle. Please try again.
        </div>
      ) : (
        <>
          <section className="ds-vehicle-summary">
            <h1>{vehicleTitle || "Vehicle Details"}</h1>
            <div className="ds-vehicle-summary__details">
              <div className="ds-vehicle-summary__field">
                <span>VIN</span>
                <strong>{vehicle.vin || "—"}</strong>
              </div>
              <div className="ds-vehicle-summary__field">
                <span>License Plate</span>
                <strong>{vehicle.plate || "—"}</strong>
              </div>
              <div className="ds-vehicle-summary__field ds-vehicle-summary__field--wide">
                <span>Color / Engine</span>
                <strong>
                  {[vehicle.exterior_color, vehicle.engine_type]
                    .filter(Boolean)
                    .join(" | ") || "—"}
                </strong>
              </div>
            </div>
          </section>

          <div className="ds-vehicle-history__heading">
            <div>
              <h2>Activity History</h2>
              <span>
                {activities.length} {activities.length === 1 ? "activity" : "activities"}
              </span>
            </div>
            <label className="ds-vehicle-sort">
              <span>Sort by date</span>
              <select
                aria-label="Sort activity history by date"
                value={sortOrder}
                onChange={(event) => setSortOrder(event.target.value)}
              >
                <option value="oldest">Oldest first</option>
                <option value="newest">Newest first</option>
              </select>
            </label>
          </div>

          <div className="ds-vehicle-history">
            {activities.length ? (
              activities.map((details, index) => (
                <Link
                  key={details.id || index}
                  to={`/activity/${details.id}`}
                  className="ds-vehicle-activity"
                >
                  <div className="ds-vehicle-activity__layout">
                    <div className="ds-vehicle-activity__main">
                      <strong className="ds-vehicle-activity__date">
                        {details.date
                          ? convertToMonthDayYear(details.date)
                          : "Date unavailable"}
                      </strong>
                      <div className="ds-vehicle-activity__type">
                        {[details.activity_type, details.activity_detail_type]
                          .filter(Boolean)
                          .join(" | ")}
                        {details.alternate_to && String(details.alternate_to).trim() && (
                          <span className="ds-vehicle-activity__contact">
                            {" - "}{details.alternate_to}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="ds-vehicle-activity__right">
                      <span className="ds-vehicle-activity__workorder">
                        WO: {formatWorkOrder(details.work_order_number)}
                        <span aria-hidden="true"> ›</span>
                      </span>
                      <span className="ds-vehicle-activity__mileage">
                        {details.start_mileage ?? "—"}
                        {details.end_mileage != null && details.end_mileage !== ""
                          ? ` → ${details.end_mileage}`
                          : ""}
                      </span>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              !isLoading && (
                <div className="ds-vehicle-history__empty">
                  No activity history available for this vehicle.
                </div>
              )
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Vehicle;
